import React from "react";
import { TabMenuContainer } from "../../../../common/styled/project";

const TabMenu = ({ tabs, activeIndex, onChange }) => {
  return (
    <TabMenuContainer>
      {tabs.map((tab, idx) => (
        <li
          key={idx}
          className={activeIndex === idx ? "active" : "inactive"}
          onClick={() => onChange(idx)}>
          {tab}
        </li>
      ))}
    </TabMenuContainer>
  );
};

export default TabMenu;
